// Constants and utilities for POS
import { Scissors, Package } from 'lucide-react';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BUSINESS_LOGOS = {
  'The Holland Barbershop': 'https://customer-assets.emergentagent.com/job_cutsync-2/artifacts/sfpd5g0k_The%20Holland.jpeg',
  'Paulo Cisneros': 'https://customer-assets.emergentagent.com/job_cutsync-2/artifacts/7hd0na99_Paulo%20Cisneros.jpeg',
};

export const iconMap = {
  scissors: Scissors,
  package: Package,
  droplet: () => <span className="text-2xl">💧</span>,
  hand: () => <span className="text-2xl">✋</span>,
};

export const STATUS_COLORS = {
  pending: 'bg-yellow-500/20 border-yellow-500/50 text-yellow-500',
  confirmed: 'bg-green-500/20 border-green-500/50 text-green-500',
  completed: 'bg-zinc-500/20 border-zinc-500/50 text-zinc-400',
};

export const STATUS_LABELS = {
  pending: 'Pendiente',
  confirmed: 'Confirmada',
  completed: 'Completada',
};
